import { render, staticRenderFns } from "./CardRemuneracao.vue?vue&type=template&id=4fd2bbb2&scoped=true"
import script from "./CardRemuneracao.vue?vue&type=script&lang=ts"
export * from "./CardRemuneracao.vue?vue&type=script&lang=ts"
import style0 from "./CardRemuneracao.vue?vue&type=style&index=0&id=4fd2bbb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2bbb2",
  null
  
)

export default component.exports